module.exports = __webpack_public_path__ + "9989b1ee6ce7f16cd3e912ebd0779815.png";